import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { faqs } from '../data/salesCopy';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-70" data-mp="1hdup6krjl7as">
      <div className="mx-auto max-w-3xl" data-id="element-71" data-mp="1cfjc815yagoc">
        <SectionTitle data-id="element-72" data-mp="1ccdnwo55bito">Frequently Asked Questions</SectionTitle>

        <div className="mt-5 space-y-1.5" data-id="element-73" data-mp="2a175web0ukw6">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-lg border border-brand-sand/70 bg-white shadow-sm" data-id="element-74" data-mp="251b6yth6ljnh" data-mpi={i}>
                <h3 data-id="element-75" data-mp="1v4g6w659fb73">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-2 px-3 py-2.5 text-left font-sans text-[13px] font-bold leading-snug text-brand-charcoal transition-colors duration-150 ease-smooth hover:text-brand-sage sm:text-sm" data-id="element-76" data-mp="1v72da2gezknq">
                    {faq.q}
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand-clay transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-77" data-mp="1arwv93lpo45v" />
                  </button>
                </h3>
                {isOpen && <p id={`faq-${i}`} className="px-3 pb-2.5 text-[12.5px] font-medium leading-snug text-brand-charcoal/80 sm:text-[13.5px]" data-id="element-78" data-mp="s0mal46kwnmf">
                    {faq.a}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}